import React from "react";
import FloatingLabelInput from "./floating-label-input";
import DateOfBirthSelect from "./date-of-birth-select";
import AddressInput from "./address-input";
import UkAddressInput from "./uk-address-input";

const FormField = ({
  field,
  form,
  settings,
  componentKey,
  showMoreFields,
  onDobChange,
  onAddressChange,
  isSinglePageForm = false,
  disabled = false,
}) => {
  const shouldSkipValidation =
    componentKey === "idmatch/coppa" &&
    !showMoreFields &&
    (field.name === "dob" || field.name === "ssn");

  const inputProps = shouldSkipValidation
    ? {
        value: form.values[field.name] || "",
        onChange: (event) =>
          form.setFieldValue(field.name, event.target.value),
      }
    : form.getInputProps(field.name);

  if (field.type === "date") {
    return (
      <DateOfBirthSelect
        key={field.name}
        onDobChange={onDobChange}
        isSinglePageForm={isSinglePageForm}
        {...inputProps}
        disabled={disabled}
      />
    );
  }

  if (field.type === "address") {
    const matchedRoute = settings?.journey?.route?.find(
      (route) => route.path === componentKey,
    );

    const isUKAddressSetting =
      settings?.journey?.settings?.isUKAddress ||
      settings?.journey?.settings?.isUkAddress ||
      matchedRoute?.settings?.isUKAddress ||
      matchedRoute?.settings?.isUkAddress ||
      matchedRoute?.isUKAddress ||
      matchedRoute?.isUkAddress;

    // One-time debug log for UK address detection
    if (field.type === "address" && componentKey === "agematch/process") {
      console.log("🏠 AgeMatch UK Address Check:", {
        isUKAddressSetting,
        componentKey,
        settings: settings?.journey?.settings,
        matchedRoute: settings?.journey?.route?.find(r => r.path === componentKey)
      });
    }

    const AddressComponent = isUKAddressSetting
      ? UkAddressInput
      : AddressInput;

    return (
      <AddressComponent
        key={field.name}
        onAddressChange={onAddressChange}
        showCityState={field.showCityState !== false}
        streetLabel={field.streetLabel}
        cityLabel={field.cityLabel}
        stateLabel={field.stateLabel}
        zipLabel={field.zipLabel}
        zipCodeLabel={field.zipCodeLabel}
        errorMessage={field.errorMessage}
        {...inputProps}
        value={{
          addr: form.values.addr,
          city: form.values.city,
          state: form.values.state,
          zip: form.values.zip,
        }}
        disabled={disabled}
      />
    );
  }

  // Special handling for phone field
  if (field.name === "phone") {
    return (
      <FloatingLabelInput
        key={field.name}
        size="xl"
        label={field.label}
        inputMode="tel"
        placeholder={field.placeholder}
        {...inputProps}
        disabled={disabled}
        customOnChange={(event) => {
          let value = event.target.value || "";
          value = value.replace(/\D/g, "").substring(0, 10);
          value = value.replace(
            /(\d{3})(\d{3})(\d{4})/,
            "$1-$2-$3"
          );
          inputProps.onChange(value);
          form.setFieldValue("phone", value);
        }}
      />
    );
  }

  return (
    <FloatingLabelInput
      key={field.name}
      size="xl"
      label={field.label}
      isPassword={field.isPassword}
      isMaskedInput={field.isMaskedInput}
      maxLength={field.maxLength}
      {...inputProps}
      disabled={disabled}
    />
  );
};

export default FormField;

